import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { OrganizationType } from '../models/Organization';

export type ProviderOrganizationType =
  | OrganizationType.REHEARSAL_STUDIO
  | OrganizationType.MUSIC_SCHOOL
  | OrganizationType.INDIVIDUAL_TUTOR;

const OPTIONS: ProviderOrganizationType[] = [
  OrganizationType.MUSIC_SCHOOL,
  OrganizationType.REHEARSAL_STUDIO,
  OrganizationType.INDIVIDUAL_TUTOR,
];

interface ProviderOrganizationTypeToggleProps {
  value: ProviderOrganizationType | null;
  onChange: (value: ProviderOrganizationType) => void;
  labels: Record<ProviderOrganizationType, string>;
  ariaLabel: string;
  disabled?: boolean;
}

const ProviderOrganizationTypeToggle: React.FC<ProviderOrganizationTypeToggleProps> = ({
  value,
  onChange,
  labels,
  ariaLabel,
  disabled,
}) => (
  <ToggleButtonGroup
    exclusive
    fullWidth
    color="primary"
    value={value}
    onChange={(_event, next: ProviderOrganizationType | null) => {
      if (next) onChange(next);
    }}
    aria-label={ariaLabel}
    disabled={disabled}
    sx={{
      display: 'flex',
      width: '100%',
      '& .MuiToggleButtonGroup-grouped': {
        flex: '1 1 0',
        minWidth: 0,
      },
      '& .MuiToggleButton-root': {
        textTransform: 'none',
        fontWeight: 600,
        py: 1.25,
        px: { xs: 1, sm: 1.5 },
        fontSize: '0.875rem',
        lineHeight: 1.25,
        whiteSpace: 'normal',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'auto',
        minHeight: 44,
      },
    }}
  >
    {OPTIONS.map((type) => (
      <ToggleButton key={type} value={type}>
        {labels[type]}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default ProviderOrganizationTypeToggle;
